import PersonaList from './PersonaList';

export default PersonaList;
